import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  iconBack: {
    minWidth: '32px',
    minHeight: '32px',
    borderRadius: 8,
  },
}))
